import * as React from 'react'

import { Box, Skeleton } from '@factorialco/deprecated-design-system'

export const HiringPipelineSkeleton = () => {
  return (
    <Box gap="s16">
      <ItemSkeleton>
        <Skeleton height="s24" width="s24" />
        <Skeleton height="s16" width="s200" />
      </ItemSkeleton>
      <ItemSkeleton>
        <Skeleton height="s24" width="s24" />
        <Skeleton height="s16" width="s120" />
      </ItemSkeleton>
      <ItemSkeleton>
        <Skeleton height="s24" width="s24" />
        <Skeleton height="s16" width="s200" />
      </ItemSkeleton>
      <ItemSkeleton>
        <Skeleton height="s24" width="s24" />
        <Skeleton height="s16" width="s140" />
      </ItemSkeleton>
    </Box>
  )
}

const ItemSkeleton = ({ children }: React.PropsWithChildren) => {
  return (
    <Box
      flexDirection="row"
      borderRadius={{ bottomLeft: 'abs008', bottomRight: 'abs008' }}
      padding="s16"
      gap="s12"
      alignItems="center"
      border={{
        all: { color: 'grey400', style: 'solid', width: 's1' },
        top: { color: 'grey400', style: 'solid', width: 's4' },
      }}
    >
      {children}
    </Box>
  )
}
